module.exports = __webpack_public_path__ + "img/lev.8b8ec226.svg";